<template>
  <div class="login">
    <div class="login_form" v-loading="loading">
      <div class="icon">
        <!-- <img src="../../assets/img/login/loginLogo2.png" alt /> -->
		<div style="margin-top:250px"></div>
        <div class="subText">
          <div class="subTextOne">云易家</div>
          <div class="subTextTwo"></div>
        </div>
      </div>
      <!-- <dv-decoration-4 style="width:5px;height:700px;" /> -->
      <div class="wrap">
        <div class="name">
         <!-- <img src="../../assets/img/login/loginLogo.png" alt="" width="220px"> -->
          <!-- <div>数智化营销平台</div>
          <dv-decoration-5 style="width: 300px; height: 40px" /> -->
        </div>

        <div class="from_info">
          <el-form
            :model="loginForm"
            status-icon
            :rules="rules"
            ref="loginForm"
            label-width="0"
            class="demo-loginForm"
          >
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                autocomplete="off"
                prefix-icon="el-icon-user"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                autocomplete="off"
                prefix-icon="el-icon-lock"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item prop="code">
              <el-input
                prefix-icon="el-icon-key"
                v-model="loginForm.code"
                auto-complete="off"
                placeholder="验证码"
                style="width: 63%"
                @keyup.enter.native="handleLogin"
              ></el-input>
              <div class="login-code">
                <img :src="codeUrl" @click="getCode" class="login-code-img" />
              </div>
            </el-form-item> -->

            <el-form-item>
              <el-button type="primary" @click="handleLogin('loginForm')"
                >立即登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
        
    </div>
    <!-- <div class="footer"> 奇蚁科技 版权所有     客服电话：4008509168</div> -->
  </div>
</template>

<script>
// import Cookies from "js-cookie";
// import { encrypt, decrypt } from '@/utils/jsencrypt'
import { mapMutations } from "vuex";
import { unlockAlarmSound } from "../until/alarmSound";
export default {
  data() {
    return {
      loading: false,
      codeUrl: "",
      captchaEnabled: "",
      loginForm: {
        uuid: "",
        username: "",
        password: "",
        code: "",
		type:1,
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getCode();
	this.getParams();
  },
  methods: {
	getParams(){
	  var token = this.$route.query.token;
	  if(token != null && token != undefined && token!=''){
          localStorage.setItem("mytoken", token);
          this.setToken(token);
          this.getUserInfo();		  
		  next()
	  }
	  console.log(this.$route.query.expires)
	  console.log(token);
	},  
    ...mapMutations("user", ["setUserName"]),
    ...mapMutations("user", ["setToken", "setUserId"]),
    getCode() {
      this.$http.getCodeImg().then((res) => {
        console.log(res);
        this.captchaEnabled =
          res.data.captchaEnabled === undefined
            ? true
            : res.data.captchaEnabled;
        if (this.captchaEnabled) {
          this.codeUrl = "data:image/gif;base64," + res.data.img;
          this.loginForm.uuid = res.data.uuid;
        }
      });
    },
    handleLogin() {
      unlockAlarmSound();
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // alert("submit!");
          this.$http.login(this.loginForm).then((res) => {
            console.log("data", res);
            let data = res.data;
            if (data.code == 200) {
              unlockAlarmSound();
              let token = "success";
              localStorage.setItem("mytoken", token);
              this.setToken(token);
			  //跳转到首页
			  this.$router.push("/");
              //this.getUserInfo();
            } else {
              this.$message.error(data.msg);
              //this.getCode()
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getUserInfo() {
      this.$http.userInfo().then((res) => {
        let data = res.data;

        if (res.data.code == 200) {
          let user = data.user;
          let userInfo = {
            username: user.userName,
            userId: user.userId,
            nickName:user.nickName
          };
          this.setUserName(userInfo.username);
          this.setUserId(userInfo.userId);

          console.log(this.$store);
          localStorage.setItem("userInfo", JSON.stringify(userInfo));
          // localStorage.setItem("mytoken", JSON.stringify(userInfo));
          console.log("马上应该跳转");
          this.$router.push("/");
        } else {
          this.$message.error(data.msg);
          return false;
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped lang='scss'>
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  // background: url("../../assets/img/login-background.jpg") no-repeat 100% 100%;
  background: url("@/assets/img/login-background.jpg") no-repeat 100% 100%;
  background-size: 100% 100%;
}
.login_form {
  width: 1000px;
  margin: 0 auto;
  border-radius: 20px;
  height: 600px;
  // box-shadow: rgba(240, 46, 170, 0.5) 5px 5px, rgba(240, 46, 170, 0.3) 10px 10px,
  //   rgba(240, 46, 170, 0.2) 15px 15px, rgba(240, 46, 170, 0.1) 20px 20px,
  //   rgba(240, 46, 170, 0.05) 25px 25px;
  // display: flex;
  // background: #ffffff;
  // //  background:rgb(38,31,83);
  // width: 60%;
  // height: 60%;
  // text-align: center;
  // border-radius: 20px;
  display: flex;

  .wrap {
    width: 500px;
    // height: 600px;
    background: #ffffff;
    border-radius: 0px 20px 20px 0px;
    opacity: 1;
    padding: 70px 45px;
    .name {
      text-align: center;
      font-size: 24px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      -webkit-background-clip: text;
      margin-bottom: 60px;
    }
  }
  ::v-deep polyline {
    stroke: rgb(63, 150, 165);
    // stroke: rgb(215, 45, 189, 0.8) !important;
  }
  .from_info {
    // margin: 27% 50px;
    ::v-deep .el-input--prefix .el-input__inner {
      // border: 1px solid rgb(254, 5, 164);
      // border-radius: 20px;
            // width: 410px;
      height: 50px;
      border-radius: 12px 12px 12px 12px;
      opacity: 1;
      border: 1px solid #E5E5E5;
    }
    .el-input{

    }
    ::v-deep .el-button--primary {
      margin-top: 20px;
      width: 410px;
      height: 53px;
      // background: rgb(215, 45, 189, 0.8);
      border: 0;
      background: #070E52;
      border-radius: 12px 12px 12px 12px;
    }
  }
  .icon {
    width: 500px;
    height: 600px;
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.4) 0%,
      rgba(255, 255, 255, 0.25) 100%
    );
    border-radius: 20px 0px 0px 20px;
    opacity: 1;
    img {
  
      width: 180px;
      height: 194px;
      margin: 150px 160px 0;
    }
  }
  .subText {
    text-align: center;
    width: 322px;
    margin: 27px auto 0;
    .subTextOne {
      width: 322px;
      height: 40px;
      font-size: 30px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      line-height: 35px;
      letter-spacing: 2px;
      -webkit-background-clip: text;
    }
    .subTextTwo {
      width: 320px;
      height: 26px;
      font-size: 16px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 23px;
      -webkit-background-clip: text;
    }
  }
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
.login-code {
  width: 33%;
  height: 50px;
  float: right;
  img {
    width: 100%;
    height: 50px;
    cursor: pointer;
    vertical-align: middle;
  }
}
.footer{
  position: fixed;
  text-align: center;
  color: #fff;
   font-size: 16px;
   bottom: 30px;
}
</style>